<template>
  <div class="results-header-wrap" :class="{'special-text': !!specialText}" ref="resultsHeader">
    <div class="results-wrapper">
      <!--            <div style="color: #0a6aa1; font-size:  14px;">{{filters}}</div>-->
      <div v-if="!specialText" class="results-count">
        <b>{{ total }}</b> leitarniðurstöður
      </div>

     <h1 v-if="specialText" class="search_special_text" v-html="specialText"></h1>

      <div v-if="!specialText" class="results-tags">
        <reset-filter class="result-clear-tags">Hreinsa síu</reset-filter>
        <button
            v-for="(filter, index) in filters"
            :key="index"
            class="result-tag"
            @click="unselectFilter(filter.type, filter.id)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10px" height="10px">
            <path
                fill="currentColor"
                fill-rule="nonzero"
                d="M9.97894737 1.13684211L8.86315789.02105263 5 3.88421053 1.13684211.02105263.02105263 1.13684211 3.88421053 5 .02105263 8.86315789l1.11578948 1.11578948L5 6.11578947l3.86315789 3.8631579 1.11578948-1.11578948L6.11578947 5z"
            />
          </svg>
          <span class="result-tag__name">{{ filter.name }}</span>
        </button>

        <save-search v-if="specialText" :filters="filters"/>
      </div>
    </div>

    <div class="results-notification-wrap">
      <span class="results-notification">Fá tilkynningar um þennan leit</span>
      <!-- v-if="!mobilecheck()" -->
      <save-search :filters="filters"/>

      <sort-menu :filters="filtersData"></sort-menu>
    </div>
    <save-search-block
        id="heightHeader"
        class="active"
        :class="{ active: $store.state.saveBtnMobileHide }"
        :sub="sub"
        :filters="filters"
        :subscriber="subscriber"
    />
  </div>
</template>

<script>
import SortMenu from "./SortMenu.vue";
import SaveSearch from "./SaveSearch.vue";
import ResetFilter from "./ResetFilter.vue";
import SaveSearchBlock from "@/components/Dealers/SaveSearchBlock.vue";
import dealers from "../mixins/dealers";
import {mapState} from "vuex";

export default {
  props: ["filters", "filtersData", "total", "is_sub", "subscriber"],
  mixins: [dealers],
  data() {
    return {
      showMain: false,
      f: [],
      // sub: false,
      offsetTopResultsHeader: 0
      // headerActiveFlag: false
    };
  },
  components: {
    SortMenu,
    SaveSearch,
    ResetFilter,
    SaveSearchBlock
  },
  mounted() {
    let elem = window;
    if (this.$store.state.isApp && this.$device.ios()) {
      elem = document.querySelector("body.ios.app #main > :nth-child(2)");
    }
/*
    elem.addEventListener("scroll", function () {
      let windowScrollTop = that.$store.state.scrollTop;
      if (!!that.$refs.resultsHeader && document.querySelector("#heightHeader")) {

        let headerOffsetTop =
            that.$refs.resultsHeader && that.$refs.resultsHeader.offsetTop;

        let heightHeader = document.querySelector("#heightHeader").offsetHeight;
        that.$store.state.saveBtnMobileHide =
            windowScrollTop + heightHeader >= headerOffsetTop;
      }
    });*/
  },
  computed: {
    ...mapState({
      specialText: state => state.specialText
    }),
    selectedFilterCount() {
      return this.$store.state.selected_filters_count;
    },
    sub() {
      return this.is_sub ? this.is_sub : false;
    },
    mobilecheck() {
      return this.$device.mobile();
    }
  }
};
</script>
